import {
  useState, useRef, useEffect,
} from 'react';

import Router from 'next/router';

export default function useIsRedirecting() {
  const isMountedRef = useRef(true);
  const [isRedirecting, setIsRedirecting] = useState(false);
  useEffect(() => {
    const onUrlChanging = () => {
      if (isMountedRef.current) {
        setIsRedirecting(true);
      }
    };
    const onUrlChanged = () => {
      if (isMountedRef.current) {
        setIsRedirecting(false);
      }
    };
    Router.events.on('routeChangeStart', onUrlChanging);
    Router.events.on('routeChangeComplete', onUrlChanged);
    return () => {
      Router.events.off('routeChangeStart', onUrlChanging);
      Router.events.off('routeChangeComplete', onUrlChanged);
    };
  }, []);
  useEffect(() => () => {
    isMountedRef.current = false;
  }, []);
  return isRedirecting;
}
